import * as React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import { X, CheckCircle2, AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastPrimitive.Provider swipeDirection="right">
      {toasts.map((t) => (
        <ToastPrimitive.Root
          key={t.id}
          open
          onOpenChange={(open) => { if (!open) dismiss(t.id); }}
          className={cn(
            'group pointer-events-auto relative flex w-full max-w-sm items-start gap-3 overflow-hidden rounded-lg border p-4 shadow-lg transition-all',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[swipe=end]:animate-out data-[state=closed]:fade-out-80',
            'data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-bottom-full',
            t.variant === 'destructive'
              ? 'border-destructive/30 bg-destructive text-destructive-foreground'
              : 'border-border bg-background text-foreground',
          )}
        >
          {/* Icon */}
          <div className="mt-0.5 shrink-0">
            {t.variant === 'destructive' ? (
              <AlertCircle className="h-4 w-4" />
            ) : (
              <CheckCircle2 className="h-4 w-4 text-emerald-500" />
            )}
          </div>

          {/* Content */}
          <div className="flex-1 space-y-0.5">
            {t.title && (
              <ToastPrimitive.Title className="text-sm font-semibold leading-tight">
                {t.title}
              </ToastPrimitive.Title>
            )}
            {t.description && (
              <ToastPrimitive.Description className="text-sm opacity-90">
                {t.description}
              </ToastPrimitive.Description>
            )}
          </div>

          {/* Close */}
          <ToastPrimitive.Close
            onClick={() => dismiss(t.id)}
            className="shrink-0 rounded-sm opacity-50 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring transition-opacity"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </ToastPrimitive.Close>
        </ToastPrimitive.Root>
      ))}

      <ToastPrimitive.Viewport className="fixed bottom-4 right-4 z-[100] flex max-h-screen w-full max-w-sm flex-col gap-2 p-0" />
    </ToastPrimitive.Provider>
  );
}
